import { JSX } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { openModalV2, goBack } from "~/shared_states/modal";

export interface OrderFailedModalProps {
  onClose?: () => void;
  reason?: string;
}

/**
 * Opens the Order Failed Modal
 * Shows when gift card generation fails
 */
export const openOrderFailedModal = (props?: OrderFailedModalProps) => {
  openModalV2(() => <OrderFailedModal {...props} />, {
    size: "medium",
  });
};

/**
 * Order Failed Modal Component
 * Displays error state when gift card generation fails
 * Fixed text as per design
 */
export function OrderFailedModal(props: OrderFailedModalProps): JSX.Element {
  const { components } = useTelescopeContext();

  const handleClose = () => {
    goBack();
    props.onClose?.();
  };

  // Build description dynamically based on whether reason is provided
  const description = () => {
    const baseMessage =
      "Any amount deducted will be refunded within 3 to 5 days.";
    if (props.reason) {
      return `${props.reason}\n\n${baseMessage}`;
    }
    return baseMessage;
  };

  return (
    <div class="relative flex flex-col overflow-hidden bg-background-normal-primary">
      <components.ModalHeader
        size="large"
        title="Gift card failed to generate"
        description={description()}
        onClose={handleClose}
      />

      <components.ModalFooter
        button={{
          text: "Close",
          onClick: handleClose,
          variant: "primary",
          style: "neutral",
          size: 40,
        }}
      />
    </div>
  );
}
